//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
  data() {
    return {
      searchText: this.$route.query.search || ''
    }
  },
  computed:{
    hiddenLabel(){
      return this.searchText.length > 0
    }
  },
  methods: {
    search() {
      const query = {...this.$route.query}
      delete query.pageNum
      if (this.searchText) {
        query.search = this.searchText
      } else {
        delete query.search
      }
      this.$router.push({
        path: this.$route.path,
        query
      })
    }
  }
}
